function basicURLValidate(url) {
    var re = new RegExp("^\\s*https?:\/\/.+", "i");
    return re.test(url);
}